module.exports = __webpack_public_path__ + "u2f_bluetooth.70fec4210efa62c0bec72284df5c6040.png";